import React from 'react';

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';

import { Template } from 'devextreme-react/core/template';

import DataGrid, {
    Column,
    ColumnChooser,
    ColumnFixing,
    FormItem,
    Pager,
    HeaderFilter,
    Form,
    Lookup,
    Grouping,
    GroupPanel,
    Export,
    Scrolling,
    SearchPanel,
    Selection,
    StateStoring
} from 'devextreme-react/data-grid';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import { CheckBox } from 'devextreme-react';
import CustomStore from "devextreme/data/custom_store";
import 'whatwg-fetch';



const allowedPageSizes = [10, 15, 20, 25, 30, 50, 100];

class TaxFormScheduleJOfficer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            autoExpandAll: true,
            showColumnLines: true,
            showRowLines: true,
            showBorders: true,
            rowAlternationEnabled: false,
            allowColumnReordering: true,
            wordWrapEnabled: true,
            columnAutoWidth: true,
            showColumnHeaders: true
        };

        this.onToolbarPreparing = this.onToolbarPreparing.bind(this);
        this.dataGrid = null;

        this.onAutoExpandAllChanged = this.onAutoExpandAllChanged.bind(this);
    }

    currencyFormat = { style: 'decimal', useGrouping: true };

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'totalGroupCount'
        }, {
            location: 'before',
            widget: 'dxSelectBox',
            options: {
                width: 200,
                items: [{
                    value: 'Id',
                    text: 'Grouping by Id'
                }, {
                    value: 'taxPayerName',
                    text: 'Grouping by Tax Payer Name'
                }],
                displayExpr: 'text',
                valueExpr: 'value',
                value: 'remoteDataSource'
            }
        }
            ,
            {
                location: 'after',
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    onClick: this.refreshDataGrid.bind(this)
                }
            });
    }

    refreshDataGrid() {
        this.dataGrid.instance.refresh();
    }

    render() {
        const { allowColumnReordering, wordWrapEnabled, columnAutoWidth, showColumnHeaders, showColumnLines, showRowLines, showBorders, rowAlternationEnabled } = this.state;
        return (
            <div>
                <DataGrid
                    //DataGrid id="gridContainer"
                    //ref={(ref) => this.dataGrid = ref}
                    dataSource={gridDataSource}
                    keyExpr="id"
                    allowColumnReordering={allowColumnReordering}
                    wordWrapEnabled={wordWrapEnabled}
                    columnAutoWidth={columnAutoWidth}
                    showColumnHeaders={showColumnHeaders}
                    showColumnLines={showColumnLines}
                    showRowLines={showRowLines}
                    showBorders={showBorders}
                    rowAlternationEnabled={rowAlternationEnabled}
                >
                    <ColumnChooser enabled={true} />
                    <ColumnFixing enabled={true} />
                    <Pager
                        showPageSizeSelector={true}
                        allowedPageSizes={allowedPageSizes}
                        showNavigationButtons={true}
                        showInfo={true}
                        infoText="Page {0} of {1} ({2} Schedule J Records)"
                    />
                    <Export enabled={true} fileName="TaxFormScheduleJReport" allowExportSelectedData={true} />
                    <Selection mode="multiple" />
                    <GroupPanel visible={true} />
                    <HeaderFilter visible={true} />
                    <SearchPanel visible={true} />
                    <Grouping autoExpandAll={this.state.autoExpandAll} />

                    <Column dataField="ein" dataType="string" groupIndex={0} />
                    <Column dataField="taxpayerName" dataType="string" fixed={true} groupIndex={0} />
                    <Column dataField="taxYear" dataType="string" fixed={true} />
                    <Column dataField="addressLine1" dataType="string" visible={false} />
                    <Column dataField="city" dataType="string" format={this.currencyFormat} visible={false} />
                    <Column dataField="state" dataType="string" format={this.currencyFormat} />
                    <Column dataField="zipCode" dataType="string" format={this.currencyFormat} visible={false} />
                    <Column dataField="taxPeriod" dataType="string" visible={false}/>
                    <Column dataField="datetimecreated" dataType="string" visible={false} />
                    <Column dataField="returnVersion" dataType="string" visible={false} />
                    <Column dataField="taxPeriodEndDate" dataType="string" visible={false} />
                    <Column dataField="taxPeriodBeginDate" dataType="string" visible={false} />
                    <Column dataField="personNm" dataType="string" />
                    <Column dataField="titleTxt" dataType="string" />
                    <Column dataField="baseCompensationFilingOrgAmt" dataType="number" format={this.currencyFormat}/>
                    <Column dataField="bonusFilingOrganizationAmount" dataType="number" format={this.currencyFormat} />
                    <Column dataField="otherCompensationFilingOrgAmt" dataType="number" format={this.currencyFormat} />
                    <Column dataField="deferredCompensationFlngOrgAmt" dataType="number" format={this.currencyFormat} />
                    <Column dataField="nontaxableBenefitsFilingOrgAmt" dataType="number" format={this.currencyFormat} />
                    <Column dataField="totalCompensationFilingOrgAmt" dataType="number" format={this.currencyFormat} />
                    <Column dataField="compReportPrior990FilingOrgAmt" dataType="number" format={this.currencyFormat} />
                    <Column dataField="compensationBasedOnRltdOrgsAmt" dataType="number" format={this.currencyFormat} />
                    <Column dataField="bonusRelatedOrganizationsAmt" dataType="number" format={this.currencyFormat} />
                    <Column dataField="otherCompensationRltdOrgsAmt" dataType="number" format={this.currencyFormat} />
                    <Column dataField="deferredCompRltdOrgsAmt" dataType="number" format={this.currencyFormat} />
                    <Column dataField="nontaxableBenefitsRltdOrgsAmt" dataType="number" format={this.currencyFormat} />
                    <Column dataField="totalCompensationRltdOrgsAmt" dataType="number" format={this.currencyFormat} />
                    <Column dataField="compReportPrior990RltdOrgsAmt" dataType="number" format={this.currencyFormat} />





                </DataGrid>
                <div className="options">
                    <div className="caption">Options</div>
                    <div className="option">
                        <CheckBox text="Expand All Groups"
                            value={this.state.autoExpandAll}
                            onValueChanged={this.onAutoExpandAllChanged} />
                    </div>
                </div>
            </div>
        );
    }

    onAutoExpandAllChanged() {
        this.setState({
            autoExpandAll: !this.state.autoExpandAll
        });
    }

}

function handleErrors(response) {
    if (!response.ok)
        throw Error(response.statusText);
    return response;
}
const gridDataSource = {
    store: new CustomStore({
        //key: 'id',
        load: (values) => {
            return fetch("/api/taxformschedulejofficers", {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(result => result.json())
                .catch(handleErrors);
        },

        update: (key, values) => {
            console.log('values', values);
            var jsonString = JSON.stringify(values);
            return fetch('/api/ein/' + key, {
                method: "PUT",
                body: jsonString,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(handleErrors);
        }
    })
}

export default TaxFormScheduleJOfficer;
